import {segment} from './helpers'

export const solvvyLaunched = (activationSource) =>
  segment('Initiated Solvvy Flow', {activationSource})
